import { Component, Input } from '@angular/core';
import moment from "moment";
import { ContentHeaderBlock } from '@shared/services/hygraph/hygraph.models';
import { CategoryTag } from '@app/@shared/models/search/cti-search.model';
import { environment } from '@env/environment';
import { getCategoryTagField } from '@app/@shared/models/category-tag/category-tag.models';

@Component({
  selector: 'app-hygraph-header',
  templateUrl: './hygraph-header.component.html',
  styleUrls: ['./hygraph-header.component.scss'],
  standalone: false
})
export class HygraphHeaderComponent {
  @Input() title: string;
  @Input() header: ContentHeaderBlock;
  @Input() date: Date;

  getCategoryTags() {
    return this.header.categoryTags.filter(
      tag => environment.displayableCategoryTagTypes.includes(tag.type)
    )
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(tag => tag.name).join(', ');
  }

  getFilteredCategoryTags(): CategoryTag[] {
    if (!this.header?.categoryTags) return [];

    return this.header.categoryTags
      .map(tag => this.enrichCategoryTag(tag))
      .filter(tag => environment.displayableCategoryTagTypes.includes(tag.type))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  getCategoryTagUrl(tag: CategoryTag): string {
    const enrichedTag = this.enrichCategoryTag(tag);
    return `/category-tag/${enrichedTag.type}/${enrichedTag.key}?name=${encodeURIComponent(enrichedTag.name)}`;
  }

  getCategoryTagFilterField(tag: CategoryTag): string {
    const enrichedTag = this.enrichCategoryTag(tag);
    return getCategoryTagField(enrichedTag.type);
  }

  getAuthors() {
    return this.header.authors?.map(a => a.name).join(', ');
  }

  getDateFormatted(): string {
    return moment(this.date).format('MMMM DD, YYYY');
  }

  private enrichCategoryTag(tag: any): CategoryTag {
    // If tag already has name and type, return as is
    if (tag.name && tag.type) {
      return tag as CategoryTag;
    }

    // Extract type and name from key (e.g., "technology-battery" -> type: "technology", name: "Battery")
    const parts = tag.key.split('-');
    const type = parts[0];
    const nameParts = parts.slice(1);
    const name = nameParts.map((part: string) => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');

    return {
      key: tag.key,
      type: type,
      name: name
    };
  }
}
